module.exports = __webpack_public_path__ + "mw.svg?3027cb16d0f7294f56fad734e9690aa7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mw.svg
// module id = 1082
// module chunks = 27